import { Outlet } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
const DashboardViews = () => {
  return (
    <div className="container p-4 overflow-scroll">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default DashboardViews;
